import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPaperClip = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 31 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M22.1646 10.1662L13.3854 19.041C12.3415 20.0963 10.6489 20.0963 9.605 19.041C8.55887 17.9835 8.56138 16.2681 9.6106 15.2137L16.4186 8.37217L18.1283 6.64383C20.2085 4.54091 23.5813 4.54091 25.6615 6.64383C27.7418 8.74675 27.7418 12.1563 25.6615 14.2592L23.9775 15.9615L17.5952 22.4134C14.2938 25.8899 9.29128 26.4189 5.79364 23.0245C2.33883 19.6718 2.92441 14.6452 6.41758 11.114L12.7748 4.68652",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgPaperClip;
